function Profile(profileData) {
    let profile = profileData || {};
    this.id = profile.profileId;
    this.role = profile.role.enumName;
    this.isDefault = profile.isDefault;
}

module.exports = Profile;